var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"row"},[_c('v-col',{attrs:{"cols":"12","lg":"6","md":"6"}},[_c('ScaleList')],1),_c('v-col',{attrs:{"cols":"12","lg":"6","md":"6"}},[_c('ScaleSwapList')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }